import WithContactSupportAttributes from '../shared/contact-modal/WithContactSupportAttributes';
import WithContactUsAttributes from '../shared/contact-modal/WithContactUsAttributes';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Bootstrap JS functionality
import Logo from '../shared/logo';

const RuleMenuItem = ({ item, index }) => {
    return (
        <>
            {/* Vertical rule for desktop view */}
            <li className="vr my-1 d-none d-lg-block" key={`vr-${index}`}></li>

            {/* Horizontal rule for mobile view */}
            <li className="d-block d-lg-none w-100" key={`hr-${index}`}>
                <hr className="dropdown-divider my-2 hr" />
            </li>
        </>
    );
};

const DropdownMenuItem = ({ item, index }) => {
    return (
        <li className="nav-item dropdown" key={index}>
            <button className="btn dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                {item.text}
            </button>
            <ul className="dropdown-menu">
                {item.items.map((subItem, subIndex) => (
                    <li key={subIndex}>
                        <a className="dropdown-item" href={subItem.href}>
                            {subItem.text}
                        </a>
                    </li>
                ))}
            </ul>
        </li>
    );
};

const TextMenuItem = ({ item, index }) => {
    return (
        <li className="nav-item" key={index}>
            <a className="btn" href={item.href} aria-expanded="false">
                {item.text}
            </a>
        </li>
    );
};

const MenuItem = ({ item, index }) => {
    if (item.type === 'rule') {
        return RuleMenuItem({ item, index });
    }

    if (item.type === 'contact-us') {
        return (
            <li className="nav-item" key={index}>
                <a className="btn" href="/" aria-expanded="false" {...WithContactUsAttributes()}>
                    {item.text}
                </a>
            </li>
        );
    }

    if (item.type === 'support') {
        return (
            <li className="nav-item" key={index}>
                <a className="btn" href="/" aria-expanded="false" {...WithContactSupportAttributes()}>
                    {item.text}
                </a>
            </li>
        );
    }

    if (item.items || item.type === 'dropdown') {
        return DropdownMenuItem({ item, index });
    }

    return TextMenuItem({ item, index });
};

const TopNavigation = (topMenu) => {
    return (
        <nav className="navbar navbar-expand-lg">
            <div className="container-fluid">
                <a className="navbar-brand" href="/">
                    <Logo />
                </a>

                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#topNavMenu"
                    aria-controls="topNavMenu"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="topNavMenu">
                    <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                        {topMenu.items.map((item, index) => (
                            <MenuItem item={item} index={index} key={index} />
                        ))}
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default TopNavigation;